import React, { useEffect, useState } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';

function OrderDetailPage() {
  const { orderId } = useParams();
  const [order, setOrder] = useState(null);
  const [error, setError] = useState('');
  const [token] = useState(localStorage.getItem('adminToken'));
  const navigate = useNavigate();

  useEffect(() => {
    const fetchOrder = async () => {
      try {
        if (!token) throw new Error('Unauthorized: Admin token missing');
        const res = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/admin/orders/${orderId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (!res.ok) {
          const errorData = await res.json();
          throw new Error(errorData.message || 'Failed to load order');
        }

        const data = await res.json();
        setOrder(data);
      } catch (err) {
        setError(err.message);
      }
    };

    fetchOrder();
  }, [orderId, token]);

  if (error) return <div className="alert alert-danger">{error}</div>;
  if (!order) return <div>Loading...</div>;

  const handleViewBill = () => {
    navigate(`/bill/${order.orderId}`);
  };

  return (
    <div className="container my-4">
      <h2>Order Details</h2>
      <hr />
      <h5>Order ID: {order.orderId}</h5>
      <p>
        <strong>Status:</strong>{' '}
        <span className="badge bg-info">{order.status}</span>
      </p>
      <p>
        <strong>Total:</strong> ₹{order.totalPrice.toFixed(2)}
      </p>

      <h5 className="mt-4">Customer Details</h5>
      <p>Name: {order.deliveryDetails?.name || 'N/A'}</p>
      <p>Phone: {order.deliveryDetails?.mobile || 'N/A'}</p>
      <p>
        Address: {order.deliveryDetails?.address}, {order.deliveryDetails?.city} -{' '}
        {order.deliveryDetails?.pincode || 'N/A'}
      </p>

      <h5 className="mt-4">Items</h5>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>Name</th>
            <th>Weight</th>
            <th>Quantity</th>
            <th>Price (₹)</th>
          </tr>
        </thead>
        <tbody>
          {order.items.map((item, i) => (
            <tr key={i}>
              <td>{item.name}</td>
              <td>{item.weight}</td>
              <td>{item.quantity}</td>
              <td>{item.price.toFixed(2)}</td>
            </tr>
          ))}
        </tbody>
      </table>

      <button
        className="btn btn-primary me-2"
        onClick={handleViewBill}
        style={{ minWidth: '150px' }}
      >
        View Printable Bill
      </button>

      <Link to="/orders" className="btn btn-secondary mt-3">
        Back to Orders
      </Link>
    </div>
  );
}

export default OrderDetailPage;
